<button type="button" aria-label="Log Out" class="flex-1 transform transition hover:scale-105 opacity-75 hover:opacity-100" title="Log out" (click)="logout()">
    <hero-icon name="logout" type="outline" class="w-8 h-8"></hero-icon>
    <span class="sr-only">Log Out</span>
</button>
